import {saveData, getData} from "../db/db_helper"

//load from DB
export const getTimestamp = async () =>{
    return await getData("sync_timestamp") || null
}

export const saveTimestamp = async (obj) =>{
    saveData("sync_timestamp", obj)
}